import { Injectable } from '@angular/core';
import { JsonHubProtocol } from '@aspnet/signalr';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GatewayServiceProvider } from './gateway.service';
import { RequestHelperProvider } from './request-helper';
import utils from './../utils';
import { OrederRemarks } from '../_models/order/order-remarks.model';
import { empty } from 'rxjs';
import { BookingRequest } from '../_models/booking/booking-request.model';
import { StorageKeys } from '../_constants';
import { StorageServiceProvider } from './storage.service';
import {  CryptoService } from './../_services/services';


@Injectable({
  providedIn: 'root' 
})
export class BookingServiceProvider {
    constructor(private http: HttpClient,public cryptoService: CryptoService ,private gatewayService: GatewayServiceProvider, private helper: RequestHelperProvider,
        private storage: StorageServiceProvider) {

    }
    public GetOpenBooking(customerId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentType = localStorage.getItem('AgentType');
            let invoiceNumber = '';
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            
            let url = `/culturahub/RESTActivityWebService/agris.relational/Bookings?where=<<Bookings.Status>> ne 'V' and (<<Bookings.NameID>> eq ?) and (<<Bookings.InvoiceNumber>> eq ?) and(<<Bookings.VoidDate>> lt ?)&param0=${customerId}&param1=&param2=1901-01-01T05:00:00.0000000Z`
            if (agentType == 'SQL') {
                url = `/culturahub/RESTActivityWebService/agris.relational/Bookings?where=<<Bookings.Status>> ne 'V' and (<<Bookings.TenantID>> eq ?) and (<<Bookings.NameID>> eq ?) and (<<Bookings.InvoiceNumber>> eq ?) and(<<Bookings.VoidDate>> lt ?)&param0=${dataSet.TenantID}&param1=${customerId}&param2=&param3=1901-01-01T05:00:00.0000000Z`
            }

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, '[Booking:BookingRemarks]', (data) => {
                resolve(data);
            }, (error) => {
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public GetOpenPrepays(customerId): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentType = localStorage.getItem('AgentType');
            let url = `/culturahub/RESTActivityWebService/agris.relational/PaymentApplication?where=(<<PaymentApplication.NameID>> eq ?) and(<<PaymentApplication.PrepaymentType>> ne ?) and(<<PaymentApplication.InvoiceNumber>> eq ? ) and(<<PaymentApplication.VoidDate>> lt ?)&param0=${customerId}&param1&param2&param3=1901-01-01T05:00:00.0000000Z`
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);

            if (agentType == 'SQL') {
                url = `/culturahub/RESTActivityWebService/agris.relational/PaymentApplication?where=(<<PaymentApplication.TenantID>> eq ?) and(<<PaymentApplication.NameID>> eq ?) and(<<PaymentApplication.PrepaymentType>> ne ?) and(<<PaymentApplication.InvoiceNumber>> eq ?) and(<<PaymentApplication.VoidDate>> lt ?)&param0=${dataSet.TenantID}&param1=${customerId}&param2=&param3=&param4=1901-01-01T05:00:00.0000000Z`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, '[Payment:PaymentRemarks]', (data) => {
                resolve(data);
            }, (error) => {
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public GetDefaultBankCode(location): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.TenantID>> eq ? and <<PackageSetupToken.PackageCode>> eq ? and <<PackageSetupToken.SetupToken>> eq ? and <<PackageSetupToken.Location>> eq ? &param0=${dataSet.TenantID}&param1=ACR&param2=BANK_CODE_DEF&param3=${location}`
            }
            else {
                url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?PackageCode=ACR&SetupToken=BANK_CODE_DEF&Location=${location}`
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, '[Payment:PaymentRemarks]', (data) => {
                resolve(data[0]);
            }, (error) => {
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public GetPackageSetupToken(packageCode): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.TenantID>> eq ? and <<PackageSetupToken.PackageCode>> eq ? &param0=${dataSet.TenantID}&param1=${packageCode}`
            }
            else {
                url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?PackageCode=${packageCode}`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
                resolve(data);
            }, (error) => {
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }

    GetOrderRemarksConfiguration(visible?: boolean): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            let orderRemarks: OrederRemarks[] = [];
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenentId = dataSet ? dataSet.TenantID : '';
            let remoteUrl = visible === null || visible === undefined
                ? `${utils.GetSalesReviewRemoteServer()}/OrderRemarksConfig/Config/${tenentId}`
                : `${utils.GetSalesReviewRemoteServer()}/OrderRemarksConfig/Config/${tenentId}/${visible}`;
            this.http.get(remoteUrl, {
                headers: {},
            }).pipe(map(data => data)).subscribe((data: any) => {
                if (data.TransactionObject) {
                    data.TransactionObject.forEach(orderRemark => {
                        let remark = new OrederRemarks();
                        remark.configId = orderRemark.ConfigId;
                        remark.tenantId = orderRemark.TenantId;
                        remark.visible = orderRemark.Visible;
                        remark.orderRemarksId = orderRemark.RemarksId;
                        remark.label = orderRemark.Label;
                        remark.begRange = orderRemark.BegRange;
                        remark.endRange = orderRemark.EndRange;
                        remark.location = orderRemark.Location;
                        remark.required = orderRemark.Required;

                        orderRemarks.push(remark);
                    });
                }
                resolve(orderRemarks);
            },
                (error) => {
                    reject(error);
                }
            );
        })
        return promise;
    }

    PostBooking(request: BookingRequest, isAutoPost = false): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let agrisLicense = JSON.parse(localStorage.getItem('agrisLicense'));
            let settings = this.storage.get(StorageKeys.Settings);

            request.agentId = localStorage.getItem('AgentId');
            request.tenantId = dataSet ? dataSet.TenantID : '';
            request.location = utils.getLocation();
            request.user = {
                userId: agrisLicense.username
            }
            let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/BookingsV2/booking`;

            if (isAutoPost) {
                request.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
                if (agrisLicense) {
                    request.approveBookingRequest.user = agrisLicense.username;
                    request.approveBookingRequest.password = agrisLicense.password;
                    request.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
                    request.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
                }
                request.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';

                remoteUrl = `${utils.GetSalesReviewRemoteServer()}/BookingsV2/bookingAndApprove`;
            }
            this.http.post(remoteUrl, request, {
                headers: {},
            }).pipe(map(data => data)).subscribe((data: any) => {
                resolve(data);
            },
                (error) => {
                    reject(error);
                }
            );
        })
        return promise;
    }



    GetUserPermissions(): Promise<any> {
        let promise = new Promise((resolve, reject) => {

            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            var request = {
                agentId: localStorage.getItem('AgentId'),
                password: null,
                tenantId: dataSet ? dataSet.TenantID : '',
                sessionId: settings.agentSessionId,
                userId: JSON.parse(localStorage.getItem('agrisLicense')).username
            }

            let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/SettingsV2/GetUserPermissions`;
            this.http.post(remoteUrl, request, {
                headers: {},
            }).pipe(map(data => data)).subscribe((data: any) => {
                resolve(data.TransactionObject);
            },
                (error) => {
                    reject(error);
                }
            );
        })
        return promise;
    }

    getPdfFromURL(url:string, BookingID:string): Promise<any> {
        return new Promise((resolve, reject) => {

            this.http.get(decodeURIComponent(url), {
                headers: {
                    'Content-Type': 'application/pdf',
                },
                'responseType': 'arraybuffer' // responseType is a sibling of headers, not a child
            })
                .pipe(map(data => data))
                .subscribe(data => {

                    if (data) {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        if (link) {
                            link.href = url;
                            link.setAttribute('download', BookingID + '.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                    resolve(data);
                },
                    (error) => {
                        reject(error);
                    }

                )
        });



    }


    DownloadprintTransaction(url,bookingID :string,isPending,BookingNumber:string) {
       
        
        let pdfLink = `${url}/BookingsV2/GetPrintForm?id=${ this.cryptoService.encryptString(String(bookingID))}&isPending=${isPending}`;
        let encodeURI = encodeURIComponent(pdfLink)

        return new Promise((resolve, reject) => {

            this.http.get(pdfLink, {
                headers: {
                    'Content-Type': 'application/pdf',
                },
                'responseType': 'blob' // responseType is a sibling of headers, not a child
            })
                .pipe(map(data => data))
                .subscribe(data => {

                    if (data) {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        if (link) {
                            link.href = url;
                            link.setAttribute('download', BookingNumber + '.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                    resolve(data["TransactionObject"]);
                },
                    (error) => {
                        reject(error);
                    }

                )
        });



    }

    getPendingBooking(FilerValue:number=0, pageNumber: number = 1, pageSize: number = 50, sortBy: string = 'BookingDate', sortOrder: string = 'DESC'): Promise<any> {
        return new Promise((resolve, reject) => {   
        let agentId = localStorage.getItem('AgentId');
        let dataSet = this.storage.get(StorageKeys.DataSet);
        let user = JSON.parse(localStorage.getItem('agrisLicense'));
        let username = '';
        if (user)
          username = user.username;
        let disableQuotesExpiry = (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).disableQuotesExpiry : true;
            
        let transactionType :string ='';
          switch(FilerValue){
            case 0:
            case 1:
            case 2:
                transactionType ='book,prepay,order,quote';
                break;
            case 3:
                transactionType ='quote';
                break;
            case 4:
                transactionType ='book';
                break;
            case 5:
                transactionType ='prepay';
                break;
            case 6:
                transactionType ='order';
                break;

          }


        let tenentId = dataSet ? dataSet.TenantID : '';
        let sessionId =  this.storage.get(StorageKeys.Settings).agentSessionId.replace('}', '').replace('{', '');
        let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/BookingsV2/pending-paginated/${agentId}/${tenentId}/${sessionId}/${username}/true?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&transactionType=${transactionType}&onlyOwnBookings=true`;
        this.http.get(remoteUrl, {
          headers: {},
        }).pipe(map(data => data)).subscribe(data => {
          resolve(data);
        },
          (error) => {
            reject(error);
          }
        );
     });
    }

    getApprovedBooking(FilerValue:number=0, pageNumber: number = 1, pageSize: number = 50, sortBy: string = 'BookingDate', sortOrder: string = 'DESC'): Promise<any> {
        return new Promise((resolve, reject) => {   
          let agentId = localStorage.getItem('AgentId');
          let dataSet = this.storage.get(StorageKeys.DataSet);
          let user = JSON.parse(localStorage.getItem('agrisLicense'));
          let username = '';
          if (user)
            username = user.username;
          let disableQuotesExpiry = (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).disableQuotesExpiry : true;
    
          let transactionType :string ='';
          switch(FilerValue){
            case 0:
            case 1:
            case 2:
                transactionType ='book,prepay,order,quote';
                break;
            case 3:
                transactionType ='quote';
                break;
            case 4:
                transactionType ='book';
                break;
            case 5:
                transactionType ='prepay';
                break;
            case 6:
                transactionType ='order';
                break;

          }


          let tenentId = dataSet ? dataSet.TenantID : '';
          let sessionId =  this.storage.get(StorageKeys.Settings).agentSessionId.replace('}', '').replace('{', '');
          let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/BookingsV2/approved-paginated/${agentId}/${tenentId}/${sessionId}/${username}/true?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&transactionType=${transactionType}&onlyOwnBookings=true`;
          this.http.get(remoteUrl, {
            headers: {},
          }).pipe(map(data => data)).subscribe(data => {
            resolve(data);
          },
            (error) => {
              reject(error);
            }
          );
        });
    };

}